import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAxiosInstance } from "../../../services/Interceptor";
import { CreateAccolade } from "../../../services/AthleteService";
import LoadingSpinner from "../../../components/LoadingSpinner";

const Accolade = () => {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, reset } = useForm();
  const apiInstance = useAxiosInstance();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      await CreateAccolade(apiInstance, data);
      toast.success("Accolate created successfully!", {
        position: "top-center",
      });
    } catch (error) {
      toast.error("Failed to created Accolate!", { position: "top-center" });
    } finally {
      setLoading(false);
      reset();
    }
    reset();
  };

  return (
    <div className="bg-white shadow-lg p-4 rounded-lg border-gray-300">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-lg font-bold mb-4">NEW ACCOLADE</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-4">
            <label
              className="block text-sm font-semibold mb-1"
              htmlFor="description"
            >
              DESCRIPTION
            </label>
            <input
              id="description"
              type="text"
              {...register("description", {
                required: "Description is required",
              })}
              placeholder="Description..."
              className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-semibold mb-1" htmlFor="year">
              YEAR
            </label>
            <input
              id="year"
              type="text"
              {...register("year", { required: "Year is required" })}
              placeholder="Year..."
              className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>
          <div className="form-field mt-4">{loading && <LoadingSpinner />}</div>
          <div className="flex justify-between mt-6">
            <button
              type="button"
              onClick={() => reset()}
              className="text-gray-600 font-semibold hover:text-gray-800"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-red-500 text-white py-2 px-6 rounded hover:bg-red-600"
            >
              ADD
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Accolade;
